//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// event-scheduler-location-input imports
import { IProps, IState } from "./EventSchedulerLocationInput.d";
import * as s from "./EventSchedulerLocationInput.styles";
// other components
// import { LocationAutocomplete } from '@components/location-settings';
// material-ui
import { TextField } from "@material-ui/core";
import { LocationOn } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
export class EventSchedulerLocationInput extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      editMode: false,
      location: props.location || "",
    };
  }

  private expand = (expand: boolean) => {
    this.setState({ editMode: expand });
  };

  private onLocationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const location = event.target.value;
    this.setState({ location });
    if (this.props.onChange) {
      this.props.onChange(location);
    }
  };

  // private results = (_placeId: string, description: string, _lat: number, _lng: number) => {
  //   this.setState({ location: description });
  //   if (this.props.onChange) {
  //     this.props.onChange(description);
  //   }
  // }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { location } = this.state;

    return (
      <div style={s.container} onClick={() => this.expand(true)}>
        <LocationOn {...s.locationIcon} />
        {/* <LocationAutocomplete
          // floatingLabelText="Add location"
          hintText="Add location"
          hintStyle={s.hint}
          underlineShow={false}
          value={location}
          results={this.results}
          popoverProps={ { style: { marginLeft: -40, width: CHROME_MAX_WIDTH } }}
          menuProps={{ menuItemStyle: { overflow: 'hidden', textOverflow: 'ellipsis' } }}
          /> */}
        <TextField
          // label="Add location"
          placeholder="Add location"
          InputProps={{
            disableUnderline: true,
          }}
          fullWidth
          value={location}
          onChange={this.onLocationChange}
          cw-id="event-scheduler-location-input"
        />
      </div>
    );
  }
}
